module.exports = __webpack_public_path__ + "static/media/logo-blue.e2d76085.svg";